import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createBlock as _createBlock, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cfd6a202"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uploader-background column items-center q-pa-lg" }
const _hoisted_2 = { class: "col" }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_iap_chip = _resolveComponent("iap-chip")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_file_picker = _resolveComponent("file-picker")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_file_picker, {
      accept: _ctx.accept,
      disable: _ctx.disable,
      "max-files": _ctx.maxFiles,
      ref: "filePicker",
      onUpload: _cache[5] || (_cache[5] = ($event: any) => (_ctx.emit('upload', $event))),
      multiple: _ctx.multiple
    }, {
      "file-uploader": _withCtx(() => [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.triggerFilePicker && _ctx.triggerFilePicker(...args))),
          onDragenter: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onDragEnter && _ctx.onDragEnter(...args))),
          onDragleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onDragLeave && _ctx.onDragLeave(...args))),
          onDragover: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onDragOver && _ctx.onDragOver(...args))),
          onDrop: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onDrop && _ctx.onDrop(...args))),
          class: _normalizeClass([{ 'drag-active': _ctx.isDragActive, 'cursor-not-allowed': _ctx.disable, 'cursor-pointer': !_ctx.disable, loading: _ctx.disable }, "uploader-container bg-grey-lighter rounded-borders"])
        }, [
          _renderSlot(_ctx.$slots, "container", {}, () => [
            _createElementVNode("div", _hoisted_1, [
              _renderSlot(_ctx.$slots, "image", {}, undefined, true),
              _renderSlot(_ctx.$slots, "label", {}, () => [
                _createElementVNode("div", _hoisted_2, [
                  _createElementVNode("div", _mergeProps({ class: "q-mt-sm" }, _ctx.TEXT_CONTENT_BODY), _toDisplayString(!_ctx.fileUploaded ? (_ctx.label ? _ctx.label : _ctx.t('UPLOADER_LABEL')) : _ctx.t('FILE_UPLOADED')), 17),
                  (!_ctx.fileUploaded)
                    ? (_openBlock(), _createElementBlock("div", _mergeProps({
                        key: 0,
                        class: "q-mt-sm row items-center justify-center"
                      }, _ctx.TEXT_SMALL_BODY), [
                        _createTextVNode(_toDisplayString(_ctx.t('SIZE_ALLOWED', { minSize: _ctx.MIN_FILE_SIZE_STRING, maxSize: _ctx.MAX_FILE_SIZE_STRING })) + " ", 1),
                        _createVNode(_component_q_icon, _mergeProps({
                          class: "q-ml-sm",
                          name: _ctx.ICONS_NAME.INFO_CIRCLE_SOLID
                        }, _ctx.ICON_PROPS.SIDE), {
                          default: _withCtx(() => [
                            _createVNode(_component_q_tooltip, _normalizeProps(_guardReactiveProps(_ctx.TOOLTIP_PROPS)), {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.t('ALLOWED_FILES') + _ctx.accept || _ctx.t('ALL_FILES')), 1)
                              ]),
                              _: 1
                            }, 16)
                          ]),
                          _: 1
                        }, 16, ["name"])
                      ], 16))
                    : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_iap_chip, {
                          tooltip: "",
                          "non-interactive": "",
                          icon: _ctx.ICONS_NAME.FILE_OUTLINE,
                          label: _ctx.fileUploaded
                        }, null, 8, ["icon", "label"])
                      ])),
                  (_ctx.browseBtn)
                    ? (_openBlock(), _createBlock(_component_q_btn, _mergeProps({
                        key: 2,
                        class: "q-mt-md",
                        onClick: _withModifiers(_ctx.triggerFilePicker, ["stop","prevent"])
                      }, _ctx.BTN_SECONDARY_MD, {
                        label: _ctx.t('BROWSE')
                      }), null, 16, ["onClick", "label"]))
                    : _createCommentVNode("", true)
                ])
              ], true)
            ])
          ], true)
        ], 34)
      ]),
      _: 3
    }, 8, ["accept", "disable", "max-files", "multiple"])
  ]))
}